export function isValidTypeformUrl(url) {
  if (!url || typeof url !== 'string') {
    return false;
  }

  try {
    const urlObj = new URL(url);
  
    if (!['http:', 'https:'].includes(urlObj.protocol)) {
      return false;
    }

    if (!urlObj.hostname || !urlObj.hostname.includes('typeform')) {
      return false;
    }

    return true;
  } catch {
    return false;
  }
}
